<script setup>

import { defineProps, defineEmits, ref, computed, watch} from "vue";
import BarraNavegacao from "./BarraNavegacao.vue";
import DadoConteudo from "./DadoConteudo.vue";
import UtilDateTime from "@utils/UtilDateTime";
import UtilID from "@/utils/UtilID";
import UtilObject from "@/utils/UtilObject";
import UtilNumber from "@/utils/UtilNumber";
import ERP from "@/api/v2/ERP.mjs";
import View from "@/api/v2/View.mjs";
import UtilArray from "@/utils/UtilArray.mjs";

//==================================================================//
//========================= Props & Emits ==========================//
//==================================================================//

const props = defineProps([
    "usuarioStore",
    "colaboradorStore",
    "dadoOriginal",
    "controlesDesativados",
    "preenchendoDadoComercial",
]);

const emits = defineEmits([
    "update:alteraControlesDesativados",
    "update:alteraPreenchendoDadoComercial",
]);

//<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
//<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
//<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//

//==================================================================//
//============================== Dado ==============================//
//==================================================================//

const dado = ref({});

//==================================================================//
//======================== Preparado Dado ==========================//
//==================================================================//

const preparadoDado = ref(false);

//<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
//<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
//<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//

//==================================================================//
//============================== NCMs ==============================//
//==================================================================//

const ncms = ref([]);

//==================================================================//
//======================= Tipos de Transporte ======================//
//==================================================================//

const tiposDeTransporte = ref([]);

//==================================================================//
//==================== Itens Tipos de Equipamento ==================//
//==================================================================//

const itensTiposDeEquipamento = ref([]);

//<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
//<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
//<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//

//==================================================================//
//=========================== Loaded NCMs ==========================//
//==================================================================//

const loadedNCMs = ref(false);

//==================================================================//
//==================== Loaded Tipos de Transporte ==================//
//==================================================================//

const loadedTiposDeTransporte = ref(false);

//==================================================================//
//================ Loaded Itens Tipos de Equipamento ===============//
//==================================================================//

const loadedItensTiposDeEquipamento = ref(false);

//<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
//<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
//<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//

//==================================================================//
//================ Loaded Altera Controles Desativos ===============//
//==================================================================//

const alteraControlesDesativados = (update = false) =>{

    emits('update:alteraControlesDesativados',update);

};

//==================================================================//
//============ Altera Preenchendo Dado Comercial ===================//
//==================================================================//

const alteraPreenchendoDadoComercial = (update = {}) =>{

    update.modal = false;
    emits('update:alteraPreenchendoDadoComercial',update);

};

//<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
//<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
//<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//

//==================================================================//
//========================= Mostra Modal ===========================//
//==================================================================//

const mostraModal = computed(()=>{

    // Se o Modal não foi ativado.
    if(props.preenchendoDadoComercial == false){
        return false;
    }

    // Se não Terminou de Carregar NCM
    if(loadedNCMs.value == false){
        return false;
    }

    // Se não Terminou de Carregar Tipos de Transporte
    if(loadedTiposDeTransporte.value == false){
        return false;
    }

    // Se não Terminou de Carregar Itens Tipos de Equipamento
    if(loadItensTiposDeEquipamento.value == false){
        return false;
    }

    // Se não Terminou de Preparar o Dado
    if(preparadoDado.value == false){
        return false;
    }

    return true;

});

//<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
//<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
//<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//

//==================================================================//
//========================= Armazena Dado ==========================//
//==================================================================//

const armazenaDado = (update) => {

    dado.value = update;

};

//==================================================================//
//========================= Altera Dado ============================//
//==================================================================//

const alteraDado = (update) => {

    update.salvo = false;
    dado.value = UtilObject.merge(dado.value, update);

};

//==================================================================//
//========================= Altera Dado ============================//
//==================================================================//

const alteraPreparadoDado = (update = false) => {

    preparadoDado.value = update;

};

//<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
//<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
//<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//

//==================================================================//
//============================ Altera NCMs =========================//
//==================================================================//

const alteraNCMs = (update = []) =>{
  
    ncms.value = update;

};

//==================================================================//
//===================== Altera Tipos de Transporte =================//
//==================================================================//

const alteraTiposDeTransporte = (update = []) =>{
  
    tiposDeTransporte.value = update;

};

//==================================================================//
//================ Altera Itens Tipos de Equipamento ===============//
//==================================================================//

const alteraItensTiposDeEquipamento = (update = []) =>{
  
    itensTiposDeEquipamento.value = update;

};

//<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
//<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
//<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//

//==================================================================//
//======================== Altera Loaded NCMs ======================//
//==================================================================//

const alteraLoadedNCMs = (update = false) =>{
  
    loadedNCMs.value = update;

};

//==================================================================//
//================= Altera Loaded Tipos de Transporte ==============//
//==================================================================//

const alteraLoadedTiposDeTransporte = (update = false) =>{
  
    loadedTiposDeTransporte.value = update;

};

//==================================================================//
//============= Altera Loaded Itens Tipos de Equipamento ===========//
//==================================================================//

const alteraLoadedItensTiposDeEquipamento = (update = false) =>{
  
    loadedItensTiposDeEquipamento.value = update;

};

//<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
//<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
//<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//

//==================================================================//
//=========================== Load NCMs ============================//
//==================================================================//

const loadNCMs = async () =>{
  
    const ncms = await ERP.getManyWithView(View.JOB_NCMS);

    alteraNCMs(ncms?.data);

    alteraLoadedNCMs(true)

};

//==================================================================//
//==================== Load Tipos de Transporte ====================//
//==================================================================//

const loadTiposDeTransporte = async () =>{
  
    const tiposDeTransporteResponse = await ERP.getManyWithView(View.JOB_TIPOS_DE_TRANSPORTE);

    alteraTiposDeTransporte(tiposDeTransporteResponse?.data);

    alteraLoadedTiposDeTransporte(true)

};

//==================================================================//
//================ Load Itens Tipos de Equipamento =================//
//==================================================================//

const loadItensTiposDeEquipamento = async() =>{
  
    const itensTiposDeEquipamentoResponse = await ERP.getManyWithView(View.JOB_ITEM_TIPOS_DE_EQUIPAMENTO);

    alteraItensTiposDeEquipamento(itensTiposDeEquipamentoResponse?.data);

    alteraLoadedItensTiposDeEquipamento(true);

};

//==================================================================//
//=================== Pega Item Proxima Sequencia ==================//
//==================================================================//

const pegaItemProximaSequencia = () => {

    let itemUltimo = UtilArray.getLast(dado?.value?.itens);
    let itemUltimoSequencia = UtilNumber.toNumber(itemUltimo?.sequencia);

    let itemNovaSequencia = `${itemUltimoSequencia+1}`;
    let itemNovaSequenciaFormatada = itemNovaSequencia?.padStart(3,"0");

    return itemNovaSequenciaFormatada;

};

//==================================================================//
//======================= Adiciona Item ============================//
//==================================================================//

const adicionaItem = () => {

    let itens = dado?.value?.itens;

    itens.push({
        id: UtilID.generateDateTimeID(),
        aberto: false,
        salvo: false,
        remover: false,
        rascunho: true,
        status: "Em desenvolvimento",
        sequencia: pegaItemProximaSequencia(),
        tipoDeEquipamento: {},
        descricao: "",
        dataPrazoEntrega: UtilDateTime.tomorrowUTC(),
        dataPrazoEntregaFormatada: UtilDateTime.tomorrowBrazil(),
        quantidade: 1,
        precoUnitario: 0,
        precoTotal: 0,
        valorBaseICMS_ISS: 0,
        porcentagemICMS: 0,
        valorICMS: 0,
        porcentagemIPI: 0,
        valorIPI: 0,
        porcentagemISS: 0,
        valorISS: 0,
        itens: [],
        itensQuantidade: 0
    });

    alteraDado({
        salvo: false,
        itens: itens,
        itensQuantidade: itens.length,
    });

};

//==================================================================//
//======================== Remove Item =============================//
//==================================================================//

const removeItem = (update) =>{

    let itens = dado?.value?.itens?.map((item)=>{

        // Ignora os Itens que não são o Item Selecionado
        if(item.id != update.id){
            return item;
        }

        // Atualiza o Item Selecionado.
        item = UtilObject.merge(item,update);

        // Exclua todos os SubItens que tenham Rascunho.
        item.itens = item?.itens?.filter(subItem => subItem.rascunho == false);

        // Recalcula quantidade de SubItens.
        item.itensQuantidade = item.itens.length;

        // Marque todos os SubItens para exclusão.
        item.itens = item?.itens?.map((subItem)=>{

            subItem.remover = update.remover;

            return subItem;

        });

        // Abra ou feche o Item com base no Array de SubItens.
        item.aberto = UtilArray.isNotEmpty(item?.itens);

        return item;

    });

    alteraDado({
        itens: itens,
        itensQuantidade: itens.length,
    });

};

//==================================================================//
//======================= Descarta Item ============================//
//==================================================================//

const descartaItem = (update) =>{

    let itens = dado?.value?.itens?.filter(item => item.id !== update.id);

    alteraDado({
        itens: itens,
        itensQuantidade: itens.length,
    });

};

//==================================================================//
//========================= Altera Item ============================//
//==================================================================//

const alteraItem = (update) => {

    let itens = dado?.value?.itens?.map((item)=>{

        // Ignora os Itens que não são o Item Selecionado
        if(item.id != update.id){
            return item;
        }

        // Altere o Item.
        item = UtilObject.merge(item, update);

        // Calcula o Preço Total do Item.
        item.precoTotal = item.quantidade * item.precoUnitario;

        // Calcula o Valor do IPI do Item.
        item.valorIPI = UtilNumber.getValueFromPercentage({porcentagem:item.porcentagemIPI, valor: item.precoTotal});

        // Atualiza o Valor de Base ICMS/ISS do Item.
        // O Valor de Base ICMS/ISS é Composto do Preço Total + Valor do IPI.
        // Apenas atualiza se: Quantidade ou Preço Unitário forem alterados.
        if(
            update?.quantidade ||
            update?.precoUnitario ||
            update?.porcentagemIPI
        ){
            item.valorBaseICMS_ISS = item.precoTotal + item.valorIPI;
        }
        
        // Atualiza o Valor dos Impostos dos Item.
        item.valorICMS = UtilNumber.getValueFromPercentage({porcentagem:item.porcentagemICMS, valor: item.valorBaseICMS_ISS});
        item.valorISS = UtilNumber.getValueFromPercentage({porcentagem:item.porcentagemISS, valor: item.valorBaseICMS_ISS});

        return item;

    });

    alteraDado({
        itens: itens
    });

};

//==================================================================//
//================= Pega Subitem Proxima Sequencia =================//
//==================================================================//

const pegaSubitemProximaSequencia = (item)=>{

    let subItemUltimo = UtilArray.getLast(item?.itens);
    let subItemUltimoSequencia = UtilNumber.toNumber(subItemUltimo?.sequencia);

    let subItemNovaSequencia = `${subItemUltimoSequencia+1}`;
    let subItemNovaSequenciaFormatada = subItemNovaSequencia?.padStart(3,"0");

    return subItemNovaSequenciaFormatada;

};

//==================================================================//
//====================== Adiciona Subitem ==========================//
//==================================================================//

const adicionaSubitem = (update) =>{

    let itens = dado?.value?.itens?.map((item)=>{

        if(item?.id != update?.id){
            return item;
        }

        item.itens.push({
            id: UtilID.generateDateTimeID(),
            salvo: false,
            remover: false,
            rascunho: true,
            sequencia: pegaSubitemProximaSequencia(item),
            status: "Em desenvolvimento",
            descricao: "",
            quantidade: 1,
            valorUnitario: 0,
            valorTotal: 0,
        });

        item.aberto = true;
        item.itensQuantidade = item.itens.length;

        return item;

    });

    alteraDado({
        itens: itens,
    });

};

//==================================================================//
//====================== Remove Subitem ============================//
//==================================================================//

const removeSubitem = (update) =>{

    let itens = dado?.value?.itens?.map((item)=>{

        // Ignora os Itens que não são o Item Selecionado
        if(item.id != update?.item?.id){
            return item;
        }

        // Ignora os SubItens que não são o Item Selecionado
        item.itens = item?.itens?.map((subItem)=>{

            if(subItem.id != update.subItem.id){
                return subItem;
            }

            // Altera os SubItens.
            subItem = UtilObject.merge(subItem,update.subItem);

            return subItem;

        });

        // Recalcula quantidade de SubItens.
        item.itensQuantidade = item.itens.length;

        // Abra ou feche o Item com base no Array de SubItens.
        item.aberto = UtilArray.isNotEmpty(item?.itens);

        return item;

    });

    alteraDado({
        itens: itens,
    });

};

//==================================================================//
//===================== Descarta Subitem ===========================//
//==================================================================//

const descartaSubitem = (update) =>{

    let itens = dado?.value?.itens?.map(item => {

        // Ignora os Itens que não são o Item Selecionado
        if(item.id != update?.item?.id){
            return item;
        }

        // Descarta SubItem.
        item.itens = item?.itens?.filter(subItem => subItem.id !== update?.subItem?.id);

        // Recalcula quantidade de SubItens.
        item.itensQuantidade = item?.itens?.length;

        // Abra ou feche o Item com base no Array de SubItens.
        item.aberto = UtilArray.isNotEmpty(item?.itens);

        return item;

    });

    alteraDado({
        itens: itens,
    });

};

//==================================================================//
//======================= Altera Subitem ===========================//
//==================================================================//

const alteraSubitem = (update) => {

    let itens = dado?.value?.itens?.map((item)=>{

        // Ignora os Itens que não são o Item Selecionado.
        if(item.id != update.item.id){
            return item;
        }

        item.itens = item?.itens?.map((subItem)=>{

            // Ignora os SubItens que não são o SubItem Selecionado.
            if(subItem.id != update.subItem.id){
                return subItem;
            }

            // Altera o SubItem.
            subItem = UtilObject.merge(subItem,update.subItem);

            // Calcula o Valor Total.
            subItem.valorTotal = subItem.quantidade * subItem.valorUnitario;

            return subItem;

        });
    
        return item;

    });

    alteraDado({
        salvo: false,
        itens: itens,
    });

};

//===================================================================//
//========================== Prepara Dado ===========================//
//=================================================-=================//

const preparaDado = (dado = {})=>{

    let itens = dado?.itens?.map((item)=>{

        let subItens = item?.itens?.map((subItem)=>{

            return{
                id: subItem?.id || "",
                salvo: true,
                remover: false,
                rascunho: false,
                codigo: subItem?.codigo || "",
                status: subItem?.status || "",
                sequencia: subItem?.sequencia || "",
                descricao: subItem?.descricao || "",
                quantidade: subItem?.quantidade || 1,
                valorUnitario: subItem?.valorUnitario || 0,
                valorTotal: subItem?.valorTotal || 0,
            };

        });

        return{
            id: item?.id || "",
            aberto: false,
            salvo: true,
            remover: false,
            rascunho: false,
            codigo: item?.codigo || "",
            status: item?.status || "",
            sequencia: item?.sequencia || "",
            ncm: item?.ncm || {},
            tipoDeEquipamento: item?.tipoDeEquipamento || {},
            descricao: item?.descricao || "",
            dataPrazoEntrega: item?.dataPrazoEntrega || "",
            dataPrazoEntregaFormatada: item?.dataPrazoEntregaFormatada || "",
            quantidade: item?.quantidade || 1,
            precoUnitario: item?.precoUnitario || 0,
            precoTotal: item?.precoTotal || 0,
            valorBaseICMS_ISS: item?.valorBaseICMS_ISS || 0,
            porcentagemICMS: item?.porcentagemICMS || 0,
            valorICMS: item?.valorICMS || 0,
            porcentagemIPI: item?.porcentagemIPI || 0,
            valorIPI: item?.valorIPI || 0,
            porcentagemISS: item?.porcentagemISS || 0,
            valorISS: item?.valorISS || 0,
            
            itens: subItens || [],
            itensQuantidade: item?.itensQuantidade || 0,
        }

    });

    let aditivos = dado?.aditivos?.map((aditivo)=>{

        return{
            id: aditivo?.id || "",
            codigo: aditivo?.codigo || "",
            descricao: aditivo?.descricao || "",
            valorAdicional: aditivo?.valorAdicional || 0,
        }

    });
    
    dado = {
        id: dado?.id || "",
        salvo: true,
        status: dado?.status || "",
        codigo: dado?.codigo || "",
        jobTipo: dado?.jobTipo || "",
        
        valorDeCusto: dado?.valorDeCusto || 0,
        valorDeVenda: dado?.valorDeVenda || 0,
        valorDeVendaComImpostos: dado?.valorDeVendaComImpostos || 0,

        descricao: dado?.descricao || "",
        condicaoDePagamento: dado?.condicaoDePagamento || "",
        observacao: dado?.observacao || "",

        dataAbertura: dado?.dataAbertura || "",
        dataAberturaFormatada: dado?.dataAberturaFormatada || "",
        
        dataEntregaContratual: dado?.dataEntregaContratual || "",
        dataEntregaContratualFormatada: dado?.dataEntregaContratualFormatada || "",
        dataEncerramento: dado?.dataEncerramento || "",
        dataEncerramentoFormatada: dado?.dataEncerramentoFormatada || "",
        
        dataEnvioAprovacaoContratual: dado?.dataEnvioAprovacaoContratual || "",
        dataEnvioAprovacaoContratualFormatada: dado?.dataEnvioAprovacaoContratualFormatada || "",
        dataEnvioAprovacaoEfetiva: dado?.dataEnvioAprovacaoEfetiva || "",
        dataEnvioAprovacaoEfetivaFormatada: dado?.dataEnvioAprovacaoEfetivaFormatada || "",
        naoTemEnvioAprovacao: dado?.naoTemEnvioAprovacao || false,
        
        dataAprovacaoPrevista: dado?.dataAprovacaoPrevista || "",
        dataAprovacaoPrevistaFormatada: dado?.dataAprovacaoPrevistaFormatada || "",
        dataAprovacaoEfetiva: dado?.dataAprovacaoEfetiva || "",
        dataAprovacaoEfetivaFormatada: dado?.dataAprovacaoEfetivaFormatada || "",
        naoTemAprovacao: dado?.naoTemAprovacao || false,
       
        dataInspecaoPrevista: dado?.dataInspecaoPrevista || "",
        dataInspecaoPrevistaFormatada: dado?.dataInspecaoPrevistaFormatada || "",
        dataInspecaoEfetiva: dado?.dataInspecaoEfetiva || "",
        dataInspecaoEfetivaFormatada: dado?.dataInspecaoEfetivaFormatada || "",
        naoTemInspecao: dado?.naoTemInspecao || false,
        
        dataEntregaFiscalPrevista: dado?.dataEntregaFiscalPrevista || "",
        dataEntregaFiscalPrevistaFormatada: dado?.dataEntregaFiscalPrevistaFormatada || "",
        dataEntregaFiscalEfetiva: dado?.dataEntregaFiscalEfetiva || "",
        dataEntregaFiscalEfetivaFormatada: dado?.dataEntregaFiscalEfetivaFormatada || "",
        naoTemEntregaFiscal: dado?.naoTemEntregaFiscal || false,
        
        dataMontagemContratual: dado?.dataMontagemContratual || "",
        dataMontagemContratualFormatada: dado?.dataMontagemContratualFormatada || "",
        dataMontagemEfetiva: dado?.dataMontagemEfetiva || "",
        dataMontagemEfetivaFormatada: dado?.dataMontagemEfetivaFormatada || "",
        naoTemMontagem: dado?.naoTemMontagem || false,

        dataStartupPrevista: dado?.dataStartupPrevista || "",
        dataStartupPrevistaFormatada: dado?.dataStartupPrevistaFormatada || "",
        dataStartupEfetiva: dado?.dataStartupEfetiva || "",
        dataStartupEfetivaFormatada: dado?.dataStartupEfetivaFormatada || "",
        naoTemStartup: dado?.naoTemStartup || false,

        dataFinalContratual: dado?.dataFinalContratual || "",
        dataFinalContratualFormatada: dado?.dataFinalContratualFormatada || "",
        dataFinalEfetiva: dado?.dataFinalEfetiva || "",
        dataFinalEfetivaFormatada: dado?.dataFinalEfetivaFormatada || "",

        solicitacaoDeOrcamentoID: dado?.solicitacaoDeOrcamento?.id || "",
        solicitacaoDeOrcamentoCodigo: dado?.solicitacaoDeOrcamento?.codigo || "",
        solicitacaoDeOrcamentoValor: dado?.solicitacaoDeOrcamento?.valor || "",

        solicitacaoDeOrcamentoTipoDeEquipamentoID: dado?.solicitacaoDeOrcamento?.tipoDeEquipamento?.id || "",
        solicitacaoDeOrcamentoTipoDeEquipamentoSigla: dado?.solicitacaoDeOrcamento?.tipoDeEquipamento?.sigla || "",
        solicitacaoDeOrcamentoTipoDeEquipamentoDescricao: dado?.solicitacaoDeOrcamento?.tipoDeEquipamento?.descricao || "",

        solicitacaoDeOrcamentoContatoComercialID: dado?.solicitacaoDeOrcamento?.contatoComercial?.id || "",
        solicitacaoDeOrcamentoContatoComercialTipo: dado?.solicitacaoDeOrcamento?.contatoComercial?.tipo || "",
        solicitacaoDeOrcamentoContatoComercialNome: dado?.solicitacaoDeOrcamento?.contatoComercial?.nome || "",

        solicitacaoDeOrcamentoContatoTecnicoID: dado?.solicitacaoDeOrcamento?.contatoTecnico?.id || "",
        solicitacaoDeOrcamentoContatoTecnicoTipo: dado?.solicitacaoDeOrcamento?.contatoTecnico?.tipo || "",
        solicitacaoDeOrcamentoContatoTecnicoNome: dado?.solicitacaoDeOrcamento?.contatoTecnico?.nome || "",

        clienteID: dado?.cliente?.id || "",
        clienteCodigo: dado?.cliente?.codigo || "",
        clienteNome: dado?.cliente?.nomeFantasia || "",
        clientePedidoDeCompra: dado?.clientePedidoDeCompra || "",
        clienteEmailXML: dado?.clienteEmailXML || "",

        comercialID: dado?.comercial?.id || "",
        comercialCodigo: dado?.comercial?.codigo || "",
        comercialNome: dado?.comercial?.nome || "",

        gestorID: dado?.gestorDeContratos?.id || "",
        gestorCodigo: dado?.gestorDeContratos?.codigo || "",
        gestorNome: dado?.gestorDeContratos?.nome || "",

        coordenadorID: dado?.coordenadorDeContratos?.id || "",
        coordenadorCodigo: dado?.coordenadorDeContratos?.codigo || "",
        coordenadorNome: dado?.coordenadorDeContratos?.nome || "",

        ncm: dado?.ncm || {},

        transporte: dado?.transporte || {},

        itens: itens || [],
        itensQuantidade: dado?.itensQuantidade || 0,

        aditivos: aditivos || [],
        aditivosQuantidade : dado?.aditivosQuantidade || 0,
    }

    armazenaDado(dado);
    alteraPreparadoDado(true);

};

//==================================================================//
//======================== Prepara Modal ===========================//
//==================================================================//

const preparaModal = async ()=>{

    await loadNCMs();
    await loadTiposDeTransporte();
    await loadItensTiposDeEquipamento();
    
    preparaDado(UtilObject.clone(props?.dadoOriginal));

}

//====================================================================//
//==== Prepara Modal se Dados Originais Carregados ou Recarregados ===//
//=============== Watch => preenchendoDadoComercial ==================//
//====================================================================//

watch(()=> props?.preenchendoDadoComercial, async() => {

    if(props?.preenchendoDadoComercial == false){
        alteraPreparadoDado(false);
    }

    if(props?.preenchendoDadoComercial == true){
        await preparaModal();
    }

},{ immediate: true });

</script>

<template>

    <main>

        <v-dialog
            content-class="c-dialog"
            v-model="mostraModal"
            fullscreen
            transition="dialog-bottom-transition"
            persistent
        >

            <v-card class="c-modal">

                <BarraNavegacao
                    :usuarioStore="props.usuarioStore"
                    :colaboradorStore="props.colaboradorStore"
                    :controlesDesativados="props.controlesDesativados"
                    :preenchendoDadoComercial="props.preenchendoDadoComercial"
                    :dado="dado"
                    @update:alteraControlesDesativados="alteraControlesDesativados"
                    @update:alteraPreenchendoDadoComercial="alteraPreenchendoDadoComercial"
                ></BarraNavegacao>

                <DadoConteudo
                    :controlesDesativados="props.controlesDesativados"
                    :preenchendoDadoComercial="preenchendoDadoComercial"
                    :ncms="ncms"
                    :tiposDeTransporte="tiposDeTransporte"
                    :itensTiposDeEquipamento="itensTiposDeEquipamento"
                    :dadoOriginal="props?.dadoOriginal"
                    :dado="dado"
                    @update:alteraDado="alteraDado"
                    @update:adicionaItem="adicionaItem"
                    @update:removeItem="removeItem"
                    @update:descartaItem="descartaItem"
                    @update:alteraItem="alteraItem"
                    @update:adicionaSubitem="adicionaSubitem"
                    @update:removeSubitem="removeSubitem"
                    @update:descartaSubitem="descartaSubitem"
                    @update:alteraSubitem="alteraSubitem"
                ></DadoConteudo>
            
            </v-card>

        </v-dialog>

    </main>

</template>

<style scoped>

.v-dialog__content >>> .v-dialog{
    background-color: white;
}

</style>